var map = {
	"./bg-BG.json": 1658,
	"./ca-ES.json": 1659,
	"./cs-CZ.json": 1660,
	"./de-DE.json": 1661,
	"./el-GR.json": 1662,
	"./en-US.json": 967,
	"./es-ES.json": 1663,
	"./et-EE.json": 1664,
	"./fi-FI.json": 1665,
	"./fr-FR.json": 1666,
	"./he-IL.json": 1667,
	"./it-IT.json": 1668,
	"./ja-JP.json": 1669,
	"./ko-KR.json": 1670,
	"./nb-NO.json": 1671,
	"./nl-NL.json": 1672,
	"./nn-NO.json": 1673,
	"./pl-PL.json": 1674,
	"./pt-BR.json": 1675,
	"./ro-RO.json": 1676,
	"./ru-RU.json": 1677,
	"./sk-SK.json": 1678,
	"./sv-SE.json": 1679,
	"./tr-TR.json": 1680,
	"./zh-CN.json": 1681
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1657;